import { websiteConfigurationActionTypes } from "../../actionTypes/websiteConfiguration/websiteConfiguration.actionTypes";

const initialState = {
  stateInfo: {
    isLoading: false,
    isSuccess: false,
    isError: false,
    error: null,
  },
  configurations: [],
  selectedConfiguration: null,
};

const websiteConfigurationReducer = (state = initialState, action) => {
  switch (action.type) {
    case websiteConfigurationActionTypes.START_ADD_OR_UPDATE_CONFIGURATION:
    case websiteConfigurationActionTypes.START_DELETE_CONFIGURATION:
    case websiteConfigurationActionTypes.START_GET_CONFIGURATION_BY_KEY:
    case websiteConfigurationActionTypes.START_GET_ALL_CONFIGURATIONS:
    case websiteConfigurationActionTypes.START_UPLOAD_LOGO_IMAGE:
    case websiteConfigurationActionTypes.START_DELETE_HOME_BANNER:
      return setStateLoading(state);

    case websiteConfigurationActionTypes.ADD_OR_UPDATE_CONFIGURATION_SUCCESS:
    case websiteConfigurationActionTypes.DELETE_CONFIGURATION_SUCCESS:
    case websiteConfigurationActionTypes.UPLOAD_LOGO_IMAGE_SUCCESS:
    case websiteConfigurationActionTypes.DELETE_HOME_BANNER_SUCCESS:
      return setStateSuccess(state);

    case websiteConfigurationActionTypes.GET_CONFIGURATION_BY_KEY_SUCCESS:
      return setSelectedConfiguration(state, action);

    case websiteConfigurationActionTypes.GET_ALL_CONFIGURATIONS_SUCCESS:
      return setConfigurations(state, action);

    case websiteConfigurationActionTypes.ADD_OR_UPDATE_CONFIGURATION_FAILURE:
    case websiteConfigurationActionTypes.DELETE_CONFIGURATION_FAILURE:
    case websiteConfigurationActionTypes.GET_CONFIGURATION_BY_KEY_FAILURE:
    case websiteConfigurationActionTypes.GET_ALL_CONFIGURATIONS_FAILURE:
    case websiteConfigurationActionTypes.UPLOAD_LOGO_IMAGE_FAILURE:
    case websiteConfigurationActionTypes.DELETE_HOME_BANNER_FAILURE:
      return setStateFailure(state, action);

    default:
      return state;
  }
};

const setStateLoading = (state) => ({
  ...state,
  stateInfo: {
    isLoading: true,
    isSuccess: false,
    isError: false,
    error: null,
  },
});

const setStateSuccess = (state) => ({
  ...state,
  stateInfo: {
    isLoading: false,
    isSuccess: true,
    isError: false,
    error: null,
  },
});

const setStateFailure = (state, action) => ({
  ...state,
  stateInfo: {
    isLoading: false,
    isSuccess: false,
    isError: true,
    error: action.error,
  },
});

const setConfigurations = (state, action) => ({
  ...state,
  configurations: action.data,
  stateInfo: {
    isLoading: false,
    isSuccess: true,
    isError: false,
    error: null,
  },
});

const setSelectedConfiguration = (state, action) => ({
  ...state,
  selectedConfiguration: action.data,
  stateInfo: {
    isLoading: false,
    isSuccess: true,
    isError: false,
    error: null,
  },
});

export default websiteConfigurationReducer;
